import { faqData } from "../data/mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";

export const FAQSection = () => {
  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-brand-50 rounded-full px-4 py-1.5 mb-5 border border-brand-100">
            <HelpCircle className="w-4 h-4 text-brand-600" />
            <span className="text-sm font-medium text-brand-700">FAQ</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto text-base">
            Expert answers to common queries about our HVAC services, VRF/VRV systems, AC tonnage calculation, and commercial air conditioning solutions.
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-3">
          {faqData.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-slate-50 border border-slate-100 rounded-xl px-6 overflow-hidden data-[state=open]:bg-brand-50/50 data-[state=open]:border-brand-200 transition-colors"
            >
              <AccordionTrigger className="text-left text-sm sm:text-base font-medium text-slate-800 hover:text-brand-700 py-5 hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
